module.exports = __webpack_public_path__ + "img/img1_md.528dd487.png";